// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","viewbox":"App_viewbox__8fSlG"};